import React, {Component} from 'react'
import Styles from "./SelectAutocomplete.module.css"
import $ from 'jquery'

class SelectAutocomplete extends Component {

    state = {
        className: this.props.validata ? "livello4" : "",
        value: this.props.value,
    }

    constructor(props) {
        super(props)

        if (this.props.className) this.state.className = this.props.className
    }

    componentDidMount() {
        $(function () {
            $('.selectpicker').selectpicker({size: 4});
        });


    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                value: this.props.value
            })
            // refresh select in caso di reset
            if (this.props.value == '') {
                $(`#${this.props.id}.selectpicker`).selectpicker('val', '')
            }
        }
    }

    render() {
        return (
            <div className={[this.state.className, "bootstrap-select-wrapper"].join(" ")}
                 id={this.props.id ? "div_" + this.props.id : "select_div"}
            >
                <select
                    data-live-search={"true"}
                    data-live-search-placeholder={"Cerca opzioni"}
                    id={this.props.id}
                    field={this.props.field}
                    value={this.state.value}
                    onChange={this.props.newSelect ? (e) => this.props.onChange(this.props.field, e) : this.props.onChange}
                    className={this.props.disabled ? [Styles.struttura, "elemento-visualizzazione", "selectpicker", Styles.disabled].join(" ") :
                        [Styles.struttura, "elemento-visualizzazione", "selectpicker", this.props.addclass? this.props.addclass : ""].join(" ")}
                    disabled={this.props.disabled}
                    style={{cursor: this.props.disabled ? "not-allowed" : ""}}
                    multiple={this.props.multiple === "true" ? this.props.multiple : ""}
                    data-multiple-separator={" | "}
                    defaultValue={this.props.defaultValue ? this.props.defaultValue : ""}
                >
                    {this.props.ricerca ? null : !this.props.vaccinazione ?
                        <option value={""} style={{backgroundColor:'white'}}>{(this.props.defaultSelect) ? this.props.defaultSelect : ""}</option> : null}
                    {this.props.functionMap}

                </select>
            </div>

        );
    }
}

export default SelectAutocomplete;

